import React from 'react';
import { Modal } from 'rsuite';
import { ButtonPrimary } from '../../../../../../../components';
import styles from './DeleteRuleModal.module.scss';

type DeleteRuleModalProps = {
  isOpen: boolean;
  onHide?: (event: React.MouseEvent) => void;
  onSubmit?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
};

const DeleteRuleModal = ({ isOpen, onHide, onSubmit }: DeleteRuleModalProps) => {
  return (
    <Modal show={isOpen} onHide={onHide} className={styles.modal}>
      <div className={styles.wrapper}>
        <div className={styles['text-wrapper']}>
          <h4>Excluir regra</h4>
          <p>
            Você está deletado uma regra, essa opção é <br /> irreversível. Você confirma essa ação?
          </p>
        </div>
        <div className={styles['action-wrapper']}>
          <ButtonPrimary type="reset" theme="ghost" onClick={onHide}>
            Cancelar
          </ButtonPrimary>
          <ButtonPrimary type="submit" skin="red" onClick={onSubmit}>
            Confirmar
          </ButtonPrimary>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteRuleModal;
